import {Subscription} from 'rxjs';

import createPlaybackStatusStream          from '../../Shared/Streams/createPlaybackStatusStream';
import IPlayerStores                       from '../../State/Shared/Interfaces/IPlayerStores';
import ISolution                           from '../Shared/Interfaces/ISolution';
import createMediaReadyStream              from '../Shared/Streams/createMediaReadyStream';
import createPlaybackStatusWithMediaStream from '../Shared/Streams/createPlaybackStatusWithMediaStream';
import subscribeToMediaReady               from '../Shared/Subscribers/subscribeToMediaReady';
import subscribeToPlaybackStatusWithMedia  from '../Shared/Subscribers/subscribeToPlaybackStatusWithMedia';
import subscribeToTimeUpdate               from '../Shared/Subscribers/subscribeToTimeUpdate';
import subscribeToVolume                   from '../Shared/Subscribers/subscribeToVolume';

const connectSolutionSubscriptions = (stores: IPlayerStores, solution: ISolution): Subscription[] => [
    subscribeToMediaReady(createMediaReadyStream(solution.mediaEvents$), stores.config, solution),
    subscribeToPlaybackStatusWithMedia(
        createPlaybackStatusWithMediaStream(
            createPlaybackStatusStream(stores.playback.update$),
            stores.media.update$
        ),
        solution
    ),
    subscribeToTimeUpdate(stores.playback.update$, solution),
    subscribeToVolume(stores.volume, solution)
];

export default connectSolutionSubscriptions;